import React from 'react';

export const StepThroughIcon = (): React.JSX.Element => {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M0.75 2.0089L0.750001 6.41575C0.750001 7.24418 1.42158 7.91575 2.25 7.91575L7.54594 7.91574M4.79074 5.16053L7.54594 7.91574L4.79074 10.9209"
				stroke="#505258"
				stroke-width="1.5"
				stroke-linejoin="round"
			/>
			<path d="M4.25001 2.75H16" stroke="#505258" stroke-width="1.5" />
			<path d="M9.75001 8C12.4837 8 13.2663 8 16 8" stroke="#505258" stroke-width="1.5" />
			<path d="M4.25001 13.25H16" stroke="#505258" stroke-width="1.5" />
		</svg>
	);
};
